var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-column-select", {
            attrs: {
              model: _vm.model,
              "is-server-column": !_vm.allowComputedFields,
              browse: _vm.browse,
            },
            model: {
              value: _vm.value.Prop,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Prop", $$v)
              },
              expression: "value.Prop",
            },
          }),
        ],
        1
      ),
      _vm.selectedField
        ? _c(
            "w-col",
            { attrs: { xs: "6", "no-margin": "" } },
            [
              _c("app-condition-operator-select", {
                attrs: {
                  label: _vm.$ct("operator"),
                  condition: _vm.value,
                  fancy: "",
                  "property-type": _vm.propertyType,
                  "full-width": "",
                },
              }),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("is-or") },
                    model: {
                      value: _vm.value.IsOr,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "IsOr", $$v)
                      },
                      expression: "value.IsOr",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  !_vm.value.UseFieldValue
                    ? _c("app-condition-value", {
                        attrs: {
                          "field-type": _vm.propertyType,
                          "has-value": _vm.hasValue,
                          operator: _vm.value.Operator,
                        },
                        model: {
                          value: _vm.value.Value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Value", $$v)
                          },
                          expression: "value.Value",
                        },
                      })
                    : _c("app-browse-condition-field-value", {
                        attrs: { value: _vm.value, model: _vm.model },
                      }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("use-field") },
                    model: {
                      value: _vm.value.UseFieldValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "UseFieldValue", $$v)
                      },
                      expression: "value.UseFieldValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }